export default __webpack_public_path__ + "static/media/Attractiveness.6b4a611a.webp";